(function () {
  'use strict';

  // ======================================================================
  // CONFIG - edit these three values
  // ======================================================================
  var CFG = {
    host:  'https://ms-b9bd79c778e2-53256.nyc.meilisearch.io',
    key:   '79783cef4c909dbbad7e475b845b161c984c55f01f66fe9d3da9c6c074d8d6b1',  // search-only key: safe in theme code
    index: 'products',
    accent: '#20a8df',   // matches the Add to Cart background
    radius: '6px',       // matches the Add to Cart corner radius
    showBar: true,         // set false to hide the persistent vehicle bar
    /* 'below' puts the search and vehicle bars under the blue nav;
       'above' puts them between the logo and the nav, so reaching the
       search box no longer drags the pointer across the menu items. */
    barPosition: 'above',
    suppressOther: true,   // hide Searchanise's dropdown and unbind it
    /* Nav entries made redundant by the garage + search bar. Match on the
       visible link text, lowercase. Remove entries to keep them. */
    hideNavLabels: ['shop by make', 'search by vehicle', 'shop by vehicle'],
    hideThemeSearch: true  // hide Turbo's own header search icon
  };
  // ======================================================================

  var LS_KEY = 'cd_garage_v1';
  var host = CFG.host.replace(/\/+$/, '');

  // ---------------------------------------------------------------- store
  // Garage holds the active vehicle plus a short history of past ones.
  var Garage = {
    read: function () {
      try {
        var raw = localStorage.getItem(LS_KEY);
        if (!raw) return { active: null, saved: [] };
        var g = JSON.parse(raw);
        return {
          active: g && g.active ? g.active : null,
          saved: (g && Array.isArray(g.saved)) ? g.saved : []
        };
      } catch (e) {
        return { active: null, saved: [] };
      }
    },
    write: function (g) {
      try { localStorage.setItem(LS_KEY, JSON.stringify(g)); } catch (e) {}
      window.dispatchEvent(new CustomEvent('cd:garage', { detail: g.active }));
    },
    get: function () { return this.read().active; },
    set: function (v) {
      var g = this.read();
      g.active = v;
      if (v) {
        g.saved = g.saved.filter(function (s) { return key(s) !== key(v); });
        g.saved.unshift(v);
        g.saved = g.saved.slice(0, 5);
      }
      this.write(g);
    },
    clear: function () {
      var g = this.read();
      g.active = null;
      this.write(g);
    },
    forget: function (v) {
      var g = this.read();
      g.saved = g.saved.filter(function (s) { return key(s) !== key(v); });
      if (g.active && key(g.active) === key(v)) g.active = null;
      this.write(g);
    }
  };

  function key(v) {
    return v ? [v.make, v.model, v.year].join('>') : '';
  }
  function label(v) {
    // Years are ranges ("07-08 Sedan"), so they read better trailing.
    return v ? [v.make, v.model, v.year].filter(Boolean).join(' ') : '';
  }
  function esc(s) { return JSON.stringify(String(s)); }
  function h(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // ------------------------------------------------------------- api calls
  function multi(queries) {
    return fetch(host + '/multi-search', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + CFG.key
      },
      body: JSON.stringify({ queries: queries })
    }).then(function (r) {
      if (!r.ok) throw new Error('Search unavailable (' + r.status + ')');
      return r.json();
    });
  }

  // The garage filter, applied to every query unless explicitly skipped.
  function vehicleFilter(v) {
    v = (v === undefined) ? Garage.get() : v;
    if (!v || !v.make) return null;
    if (v.year)  return 'fit_full = '  + esc(v.make + '>' + v.model + '>' + v.year);
    if (v.model) return 'fit_model = ' + esc(v.make + '>' + v.model);
    return 'fit_make = ' + esc(v.make);
  }

  // ---------------------------------------------------------------- styles
  var css = document.createElement('style');
  css.textContent = [
    ':root{--cd-accent:' + CFG.accent + ';--cd-radius:' + CFG.radius + ';}',
    '.cd-bar{background:#111;color:#fff;font-size:13px;width:100%;',
      'display:block;box-sizing:border-box;}',
    '.cd-bar-in{max-width:1400px;width:100%;margin:0 auto;padding:8px 16px;',
      'display:flex;align-items:center;gap:12px;flex-wrap:wrap;',
      'box-sizing:border-box;text-align:left;}',
    '.cd-bar-lbl{text-transform:uppercase;letter-spacing:.06em;font-size:11px;',
      'color:#bbb;font-weight:700;white-space:nowrap;}',
    '.cd-bar-lbl.active{color:var(--cd-accent);}',
    '.cd-bsel{flex:1 1 150px;min-width:0;max-width:230px;height:36px!important;',
      'padding:0 32px 0 10px!important;margin:0!important;border:1px solid #444;',
      'background-color:#fff;color:#111;font-size:13px;box-sizing:border-box;',
      'border-radius:var(--cd-radius);line-height:36px;cursor:pointer;',
      'appearance:none;-webkit-appearance:none;-moz-appearance:none;',
      'background-image:url(\'data:image/svg+xml;utf8,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 9L12 15L18 9\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke=\"%23111\"/></svg>\');',
      'background-repeat:no-repeat;background-position:right 8px center;',
      'background-size:18px;}',
    '.cd-bsel:disabled{background-color:#2a2a2a;color:#777;border-color:#333;',
      'cursor:default;opacity:.7;}',
    '.cd-bgo{height:36px;padding:0 18px;background:var(--cd-accent);color:#fff;',
      'border-radius:var(--cd-radius);',
      'border:none;cursor:pointer;font-size:11px;text-transform:uppercase;',
      'font-weight:700;letter-spacing:.06em;white-space:nowrap;flex:none;}',
    '.cd-bgo:hover{background:#fff;color:#111;}',
    '.cd-bclear{height:36px;padding:0 12px;background:none;border:1px solid #555;',
      'border-radius:var(--cd-radius);',
      'color:#fff;cursor:pointer;font-size:11px;text-transform:uppercase;',
      'letter-spacing:.05em;flex:none;}',
    '.cd-bclear:hover{border-color:var(--cd-accent);color:var(--cd-accent);}',
    '@media(max-width:760px){.cd-bsel{flex:1 1 100%;max-width:none;}',
      '.cd-bgo,.cd-bclear{flex:1 1 auto;}}',
    /* ---- mobile filter drawer ---- */
    '.cd-fbtn{display:none;height:38px;padding:0 16px;background:#111;color:#fff;',
      'border-radius:var(--cd-radius);',
      'border:none;cursor:pointer;font-size:11px;text-transform:uppercase;',
      'font-weight:700;letter-spacing:.06em;}',
    '.cd-scrim{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9998;display:none;}',
    '.cd-dclose{display:none;}',
    '.cd-scrim.open{display:block;}',
    '@media(max-width:860px){',
      '.cd-fbtn{display:inline-block;}',
      '.cd-drawer{position:fixed;top:0;left:0;bottom:0;width:86%;max-width:340px;',
        'background:#fff;z-index:9999;overflow-y:auto;padding:56px 18px 24px;',
        'transform:translateX(-100%);transition:transform .22s ease;',
        'box-shadow:2px 0 18px rgba(0,0,0,.2);}',
      '.cd-drawer.open{transform:translateX(0);}',
      '.cd-dclose{display:block;position:absolute;top:12px;right:12px;',
        'width:34px;height:34px;background:#111;color:#fff;border:none;',
        'font-size:19px;cursor:pointer;line-height:1;}',
    '}',
    /* The dropdown is appended to <body>, so it must be absolutely positioned
       for the inline top/left that place() sets to have any effect. Keep this
       rule intact: a malformed rule above it gets swallowed by the CSS parser
       along with this one, which silently drops the positioning. */
    '.cd-dd{position:absolute;z-index:9998;background:#fff;border:1px solid #ddd;',
      'border-radius:var(--cd-radius);',
      'box-shadow:0 8px 24px rgba(0,0,0,.14);max-height:70vh;overflow-y:auto;}',
    '.cd-dd[hidden]{display:none;}',
    '.cd-dd-note{padding:8px 12px;background:#f7f7f7;font-size:11px;color:#555;',
      'display:flex;justify-content:space-between;align-items:center;gap:8px;}',
    '.cd-dd-note button{background:none;border:none;color:var(--cd-accent);cursor:pointer;',
      'font-size:11px;text-decoration:underline;padding:0;}',
    '.cd-hit{display:flex;gap:10px;padding:9px 12px;text-decoration:none;color:#111;',
      'border-bottom:1px solid #f0f0f0;align-items:center;}',
    '.cd-hit:hover{background:#f7f9fb;}',
    '.cd-hit img{width:44px;height:44px;object-fit:contain;background:#fafafa;flex:none;}',
    '.cd-hit-w{display:flex;flex-direction:column;min-width:0;}',
    '.cd-hit-t{font-size:13px;line-height:1.3;display:block;}',
    '.cd-hit-m{font-size:11px;color:#777;margin-top:2px;display:block;}',
    '.cd-dd-all{display:block;padding:11px;text-align:center;background:#111;color:#fff;',
      'border-radius:0 0 var(--cd-radius) var(--cd-radius);',
      'text-decoration:none;font-size:12px;text-transform:uppercase;font-weight:700;letter-spacing:.05em;}',
    '.cd-dd-all:hover{background:var(--cd-accent);}',
    '.cd-dd-empty{padding:20px;text-align:center;color:#888;font-size:13px;}',
    '.cd-sbar{background:#111;width:100%;display:block;box-sizing:border-box;}',
    '.cd-sbar-in{max-width:1400px;width:100%;margin:0 auto;padding:14px 16px;',
      'display:flex;gap:0;box-sizing:border-box;text-align:left;}',
    '.cd-sbar-box{display:flex;align-items:center;width:100%;background:#fff;',
      'border-radius:var(--cd-radius);',
      'border:2px solid #fff;box-sizing:border-box;overflow:hidden;height:44px;}',
    '.cd-sbar-box:focus-within{border-color:var(--cd-accent);}',
    /* Turbo styles bare inputs with a bottom margin and its own height, which
       leaves a white strip inside the box; override both explicitly. */
    '.cd-sbar-q{flex:1 1 auto;width:100%;padding:0 14px!important;font-size:15px;',
      'border:none!important;outline:none;min-width:0;box-sizing:border-box;',
      'margin:0!important;height:40px!important;background:#fff;color:#111;',
      'line-height:40px;box-shadow:none!important;display:block;}',
    '.cd-sbar-go{flex:none;width:54px;height:40px;border:none;margin:0;padding:0;',
      'background:var(--cd-accent);color:#fff;cursor:pointer;display:flex;',
      'align-items:center;justify-content:center;}',
    '.cd-sbar-go:hover{background:#111;}',
    '.cd-sbar-go svg{display:block;}',
    /* Logo lives in the pinned row on phones only; on desktop the theme's
       own header logo is visible, so ours would be a duplicate. */
    /* Logo beside the hamburger, phones only; on desktop the theme's own
       header logo is visible and ours would duplicate it. */
    '.cd-mlogo{display:none;}',
    '@media(max-width:860px){',
      '.cd-mlogo{display:inline-flex;align-items:center;flex:none;',
        'margin-left:12px;line-height:0;text-decoration:none;}',
      '.cd-mlogo img{height:24px;width:auto;max-width:120px;',
        'object-fit:contain;display:block;}',
      '.cd-mlogo:empty{display:none;}',
    '}',

    '.cd-cnote{display:flex;justify-content:space-between;align-items:center;gap:12px;',
      'flex-wrap:wrap;padding:10px 14px;background:#f4f7f9;border-left:4px solid var(--cd-accent);',
      'margin:0 0 16px;font-size:14px;}',
    '.cd-cnote button,.cd-cnote-a{background:#111;color:#fff;border:none;',
      'border-radius:var(--cd-radius);',
      'padding:6px 12px;cursor:pointer;font-size:11px;text-transform:uppercase;',
      'font-weight:700;letter-spacing:.05em;text-decoration:none;',
      'display:inline-block;white-space:nowrap;}',
    '.cd-cnote button:hover,.cd-cnote-a:hover{background:var(--cd-accent);color:#fff;}',
    '.cd-cwrap[hidden]{display:none;}',
    '.cd-cwrap{max-width:1400px;margin:0 auto;padding:0 16px 40px;}',
    '.cd-clayout{display:grid;grid-template-columns:260px 1fr;gap:0;}',
    '@media(min-width:861px){',
      '.cd-clayout{height:calc(100vh - 190px);min-height:520px;}',
      '.cd-cside{overflow-y:auto;overflow-x:hidden;padding-right:26px;',
        'height:100%;border-right:1px solid #e0e0e0;scrollbar-gutter:stable;}',
      '.cd-cmain{overflow-y:auto;overflow-x:hidden;padding-left:26px;',
        'padding-right:16px;height:100%;scrollbar-gutter:stable;}',
    '}',
    '@media(max-width:860px){.cd-clayout{grid-template-columns:1fr;height:auto;}}',
    '.cd-csortgroup select{width:100%;padding:9px 32px 9px 10px;border:1px solid #ddd;',
      'border-radius:var(--cd-radius);',
      'font-size:14px;background-color:#fff;height:auto;margin:0;cursor:pointer;',
      'appearance:none;-webkit-appearance:none;-moz-appearance:none;',
      'background-image:url(\'data:image/svg+xml;utf8,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 9L12 15L18 9\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke=\"%23111\"/></svg>\');',
      'background-repeat:no-repeat;background-position:right 8px center;',
      'background-size:18px;}',
    '.cd-cft{text-transform:uppercase;font-weight:700;font-size:12px;',
      'letter-spacing:.06em;margin-bottom:9px;}',
    /* Rule between groups, but not trailing the last one. */
    '.cd-cfacet{padding-bottom:18px;margin-bottom:18px;',
      'border-bottom:1px solid #e6e6e6;}',
    '.cd-cfacet:last-child{border-bottom:none;padding-bottom:0;margin-bottom:0;}',
    '.cd-clist{max-height:250px;overflow-y:auto;overflow-x:hidden;',
      'padding-right:12px;scrollbar-gutter:stable;}',
    '.cd-copt{display:flex;align-items:center;gap:8px;padding:4px 0;',
      'font-size:14px;cursor:pointer;}',
    '.cd-copt:hover{color:var(--cd-accent);}',
    '.cd-copt .n{margin-left:auto;color:#888;font-size:12px;}',
    '.cd-cchk{display:flex;align-items:center;gap:8px;font-size:14px;cursor:pointer;}',
      'letter-spacing:.05em;margin-bottom:5px;}',
      'cursor:pointer;font-size:11px;text-transform:uppercase;letter-spacing:.05em;font-weight:700;}',
    '.cd-cchips{display:flex;flex-wrap:wrap;gap:7px;margin-bottom:15px;}',
    '.cd-cchip{display:inline-flex;align-items:center;gap:6px;padding:4px 10px;',
      'border-radius:var(--cd-radius);',
      'background:var(--cd-accent);color:#fff;font-size:11px;text-transform:uppercase;',
      'font-weight:700;letter-spacing:.04em;}',
    '.cd-cchip button{background:none;border:none;color:#fff;cursor:pointer;',
      'font-size:14px;padding:0;line-height:1;}',
    '.cd-cbar{display:flex;align-items:center;gap:12px;',
      'padding-bottom:11px;border-bottom:1px solid #e0e0e0;margin-bottom:16px;}',
    '.cd-ccount{font-size:14px;color:#666;white-space:nowrap;}',
    '.cd-csort{padding:7px 9px;border:1px solid #ddd;font-size:14px;',
      'width:auto;min-width:150px;max-width:210px;height:auto;line-height:1.3;',
      'background:#fff;text-transform:none;letter-spacing:normal;color:#111;',
      'font-weight:400;}',
    '.cd-cg{display:grid;grid-template-columns:repeat(auto-fill,minmax(205px,1fr));gap:18px;}',
    /* A 205px minimum leaves room for only one column on a phone, so force
       two and tighten the gutters. minmax(0,1fr) rather than 1fr: a long
       unbroken title would otherwise push the column past its share. */
    '@media(max-width:600px){',
      '.cd-cg{grid-template-columns:repeat(2,minmax(0,1fr));gap:11px;}',
      '.cd-cc-b{padding:9px;}',
      '.cd-cc-t{font-size:12px;line-height:1.3;margin:3px 0 6px;}',
      '.cd-cc-p{font-size:14px;}',
      '.cd-cc-v{font-size:9px;}',
    '}',
    '.cd-cc{border:1px solid #e5e5e5;text-decoration:none;color:inherit;display:flex;',
      'border-radius:var(--cd-radius);',
      'flex-direction:column;background:#fff;}',
    '.cd-cc:hover{border-color:#111;}',
    '.cd-cc-i{aspect-ratio:1;background:#fafafa;display:flex;align-items:center;',
      'justify-content:center;overflow:hidden;}',
    '.cd-cc-i img{width:100%;height:100%;object-fit:contain;}',
    '.cd-cc-b{padding:11px;display:flex;flex-direction:column;flex:1;}',
    '.cd-cc-v{font-size:10px;text-transform:uppercase;color:#888;letter-spacing:.05em;}',
    '.cd-cc-t{font-size:13px;line-height:1.35;margin:3px 0 8px;flex:1;}',
    '.cd-cc-p{font-weight:700;font-size:15px;}',
    '.cd-cr{font-size:12px;color:#f0a500;letter-spacing:1px;margin-bottom:5px;',
      'display:block;line-height:1;}',
    '.cd-crn{color:#888;font-size:11px;margin-left:5px;letter-spacing:0;}',
    '.cd-cc-o{font-size:10px;color:#c00;text-transform:uppercase;font-weight:700;}',
    '.cd-cmore-wrap{text-align:center;margin-top:26px;}',
    '.cd-cmore{padding:13px 30px;background:#111;color:#fff;border:none;cursor:pointer;',
      'border-radius:var(--cd-radius);',
      'text-transform:uppercase;font-weight:700;font-size:12px;letter-spacing:.06em;}',
    '.cd-cmore:hover{background:var(--cd-accent);}',
    '.cd-cempty{padding:40px;text-align:center;color:#777;}'
  ].join('');
  document.head.appendChild(css);

  if (CFG.suppressOther) {
    /* Searchanise renders collection pages too, not just the dropdown.
       Hide every element it owns; Meilisearch renders in its place. */
    var hide = document.createElement('style');
    hide.textContent = '[class*="snize"],[id*="snize"]{display:none!important;}';
    document.head.appendChild(hide);
  }

  // ------------------------------------------------------------------- bar
  // Persistent Make / Model / Year selects. Always visible, never a modal.
  var bar, sel = {};

  function isHidden(node) {
    for (var n = node; n && n !== document.body; n = n.parentNode) {
      if (n.style && n.style.display === 'none') return true;
      if (n.hidden) return true;
    }
    return false;
  }

  /* Phones get the theme's sticky header. Anything placed inside it is
     pinned too, and the vehicle picker plus search box is tall enough to
     cover most of a phone screen. Below this width the bars go after the
     sticky container instead, so they scroll away like ordinary content. */
  var MOBILE_MAX = 860;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  /* The outermost sticky or fixed ancestor of a node, or null. Outermost
     rather than nearest: the pinning comes from whichever wrapper the
     theme fixed, and we need to clear all of them. */
  function stickyAncestor(node) {
    var found = null;
    for (var n = node; n && n !== document.body; n = n.parentNode) {
      if (n.nodeType !== 1) continue;
      var pos;
      try { pos = getComputedStyle(n).position; } catch (e) { continue; }
      if (pos === 'sticky' || pos === 'fixed') found = n;
    }
    return found;
  }

  /* Put a chrome element (search bar, vehicle bar) relative to the nav.
     Anchoring to the nav rather than the content wrapper keeps the position
     stable: the wrapper gets hidden and swapped on collection pages, which
     is what used to send these to the bottom of the document. */
  function placeChrome(el) {
    var lower = document.querySelector('.lower-nav-menu');
    var anchor = lower ||
                 document.querySelector('.mega-menu-container') ||
                 document.querySelector('#shopify-section-header') ||
                 document.querySelector('header');

    if (anchor && anchor.parentNode && !isHidden(anchor)) {
      var stuck = isMobile() ? stickyAncestor(anchor) : null;

      if (stuck && stuck.parentNode) {
        // Drop below the whole pinned block. Vehicle bar first, then the
        // search bar, matching the desktop order.
        var ref = stuck;
        if (el === sbar && bar && bar.parentNode === stuck.parentNode &&
            !stuck.contains(bar)) {
          ref = bar;
        }
        stuck.parentNode.insertBefore(el, ref.nextSibling);
        return;
      }

      if (CFG.barPosition === 'above') {
        // Insert before the nav. Search bar first, then vehicle bar, so
        // they read top-to-bottom in the order they were built.
        anchor.parentNode.insertBefore(el, anchor);
        return;
      }
      // Keep search bar above vehicle bar regardless of creation order.
      var after = anchor;
      if (el === bar && sbar && sbar.parentNode === anchor.parentNode) {
        after = sbar;
      }
      anchor.parentNode.insertBefore(el, after.nextSibling);
      return;
    }

    var host = document.querySelector('.section-wrapper');
    if (host && !isHidden(host)) {
      host.insertBefore(el, host.firstChild);
      return;
    }
    if (host && host.parentNode) {
      host.parentNode.insertBefore(el, host);
      return;
    }
    document.body.insertBefore(el, document.body.firstChild);
  }

  function buildBar() {
    if (!CFG.showBar) return;
    bar = document.createElement('div');
    bar.className = 'cd-bar';
    bar.innerHTML =
      '<div class="cd-bar-in">' +
        '<span class="cd-bar-lbl">Shop by vehicle</span>' +
        '<select class="cd-bsel" data-dim="make"><option value="">Make</option></select>' +
        '<select class="cd-bsel" data-dim="model" disabled><option value="">Model</option></select>' +
        '<select class="cd-bsel" data-dim="year" disabled><option value="">Year</option></select>' +
        '<button class="cd-bgo" data-cd="apply">Find my parts</button>' +
        '<button class="cd-bclear" data-cd="clear" hidden>Clear</button>' +
      '</div>';

    placeChrome(bar);

    sel.make  = bar.querySelector('[data-dim="make"]');
    sel.model = bar.querySelector('[data-dim="model"]');
    sel.year  = bar.querySelector('[data-dim="year"]');

    sel.make.addEventListener('change', function () {
      loadModels(sel.make.value, '');
    });
    sel.model.addEventListener('change', function () {
      loadYears(sel.make.value, tail(sel.model.value), '');
    });

    loadMakes();
    renderBar();
  }

  function tail(s) { var p = String(s).split('>'); return p[p.length - 1]; }

  /* Year values are free text ranges such as "92-99", "06-13", "19-UP".
     A plain string sort puts the 1990s after the 2000s, so infer the full
     start year first: 00-30 reads as 2000s, 31-99 as 1900s. */
  function yearStart(text) {
    var m = String(text).match(/(\d{2,4})/);
    if (!m) return 9999;
    var n = parseInt(m[1], 10);
    if (m[1].length > 2) return n;
    return n <= 30 ? 2000 + n : 1900 + n;
  }

  function byYear(a, b) {
    var d = yearStart(tail(a)) - yearStart(tail(b));
    return d !== 0 ? d : String(a).localeCompare(String(b));
  }

  function facet(res, name) {
    return (res && res.facetDistribution && res.facetDistribution[name]) || {};
  }

  function fill(el, entries, placeholder, labeller, current) {
    var html = '<option value="">' + placeholder + '</option>';
    entries.forEach(function (kv) {
      html += '<option value="' + h(kv[0]) + '"' +
        (kv[0] === current ? ' selected' : '') + '>' +
        h(labeller ? labeller(kv[0]) : kv[0]) + ' (' + kv[1] + ')</option>';
    });
    el.innerHTML = html;
  }

  /* ---------------------------------------------------------- facet cache

     The fitment lists only change when the sync reindexes, but the picker
     refetches them on every pageview -- and Meilisearch bills per query,
     so a shopper with a saved vehicle was costing three searches a page
     just to redraw three dropdowns. Cache each distribution by facet name
     and filter: in memory for the page, and in localStorage so repeat
     visits and soft navigations cost nothing.

     TTL sits below the sync interval, so a catalog change is picked up the
     next day on its own. Bump FACET_CACHE_KEY to drop every cache at once. */
  var FACET_CACHE_KEY = 'cd_facets_v1';
  var FACET_TTL_MS = 12 * 60 * 60 * 1000;
  var facetMem = {};

  function facetStore() {
    try {
      var raw = localStorage.getItem(FACET_CACHE_KEY);
      if (!raw) return {};
      var o = JSON.parse(raw);
      // One timestamp for the store: these all come from the same build,
      // so they go stale together.
      if (!o || !o.t || (Date.now() - o.t) > FACET_TTL_MS) return {};
      return o.v || {};
    } catch (e) { return {}; }
  }

  function facetSave(key, dist) {
    try {
      var cur = facetStore();
      cur[key] = dist;
      localStorage.setItem(FACET_CACHE_KEY,
        JSON.stringify({ t: Date.now(), v: cur }));
    } catch (e) { /* private mode or quota: the memory cache still helps */ }
  }

  /* Resolves to a facetDistribution object, from cache when possible. */
  function cachedFacet(name, filter) {
    var key = name + '|' + (filter || []).join('&');
    if (facetMem[key]) return Promise.resolve(facetMem[key]);

    var disk = facetStore()[key];
    if (disk) { facetMem[key] = disk; return Promise.resolve(disk); }

    var q = { indexUid: CFG.index, q: '', limit: 0, facets: [name] };
    if (filter && filter.length) q.filter = filter;

    return multi([q]).then(function (d) {
      var dist = facet(d.results[0], name);
      facetMem[key] = dist;
      facetSave(key, dist);
      return dist;
    });
  }

  function loadMakes() {
    cachedFacet('fit_make', null)
      .then(function (f) {
        var v = Garage.get();
        fill(sel.make, Object.keys(f).sort().map(function (k) { return [k, f[k]]; }),
             'Make', null, v ? v.make : '');
        if (v && v.make) loadModels(v.make, v.model || '');
      })
      .catch(function () {
        sel.make.innerHTML = '<option value="">Unavailable</option>';
      });
  }

  function loadModels(make, preselect) {
    sel.model.innerHTML = '<option value="">Model</option>';
    sel.year.innerHTML = '<option value="">Year</option>';
    sel.model.disabled = !make;
    sel.year.disabled = true;
    if (!make) return;
    cachedFacet('fit_model', ['fit_make = ' + esc(make)])
      .then(function (f) {
        var entries = Object.keys(f)
          .filter(function (k) { return k.indexOf(make + '>') === 0; })
          .sort(function (a, b) { return tail(a).localeCompare(tail(b)); })
          .map(function (k) { return [k, f[k]]; });
        fill(sel.model, entries, 'Model', tail,
             preselect ? make + '>' + preselect : '');
        if (preselect) {
          var v = Garage.get();
          loadYears(make, preselect, v ? v.year : '');
        }
      });
  }

  function loadYears(make, model, preselect) {
    sel.year.innerHTML = '<option value="">Year</option>';
    sel.year.disabled = !model;
    if (!model) return;
    var prefix = make + '>' + model + '>';
    cachedFacet('fit_full', ['fit_model = ' + esc(make + '>' + model)])
      .then(function (f) {
        var entries = Object.keys(f)
          .filter(function (k) { return k.indexOf(prefix) === 0; })
          .sort(byYear)
          .map(function (k) { return [k, f[k]]; });
        fill(sel.year, entries, 'Year (optional)', tail,
             preselect ? prefix + preselect : '');
      });
  }

  function renderBar() {
    if (!bar) return;
    var v = Garage.get();
    var clear = bar.querySelector('.cd-bclear');
    var lbl = bar.querySelector('.cd-bar-lbl');
    if (clear) clear.hidden = !v;
    if (lbl) lbl.textContent = v ? 'Shopping for ' + label(v) : 'Shop by vehicle';
    if (lbl) lbl.className = v ? 'cd-bar-lbl active' : 'cd-bar-lbl';
  }

  function applyPick() {
    var make = sel.make ? sel.make.value : '';
    if (!make) return;
    var model = sel.model.value ? tail(sel.model.value) : '';
    var year  = sel.year.value  ? tail(sel.year.value)  : '';
    Garage.set({ make: make, model: model, year: year });
    if (onSearchPage()) window.dispatchEvent(new CustomEvent('cd:refresh'));
    else location.href = '/search';
  }



  // ------------------------------------------------------- site search bar
  var sbar;
  /* The theme's logo, as an <img> we can copy. Taken from the page rather
     than hardcoded to a CDN URL, so swapping the logo in the theme editor
     carries through. Anything taller than it is wide is an icon, not a
     logo, so it is skipped. */
  function themeLogoImg() {
    var cands = document.querySelectorAll(
      '.header__logo img, .site-header__logo img, .logo img, ' +
      '[class*="logo"] img, header img');
    for (var i = 0; i < cands.length; i++) {
      var im = cands[i];
      if (!im.getAttribute('src')) continue;
      if (im.closest('.cd-mlogo')) continue;          // our own copy
      if (im.naturalWidth && im.naturalHeight &&
          im.naturalWidth < im.naturalHeight) continue;
      return im;
    }
    return null;
  }

  /* The mobile menu button. Themes label it half a dozen ways, so try the
     common hooks first and fall back to an element whose visible text is
     just "menu". */
  function menuToggle() {
    // Turbo's mobile nav: <details><summary class="mobile_nav ...">
    //                       <span class="mobile-menu-title">Menu</span>
    var title = document.querySelector('.mobile-menu-title');
    if (title) return title.closest('summary') || title;

    var sels = [
      'summary.mobile_nav', '[data-mobile-nav-toggle]',
      '[data-nav-mobile-toggle]', '.mobile-nav-toggle', '.nav-mobile__toggle',
      '.header__menu-toggle', '.site-header__menu-toggle',
      '[class*="hamburger"]',
      'button[aria-label*="menu" i]', 'a[aria-label*="menu" i]'
    ];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) return el;
    }
    // Text fallback, anywhere in the document.
    var all = document.querySelectorAll('a,button,summary,div,span,label');
    for (var j = 0; j < all.length; j++) {
      var t = (all[j].textContent || '').trim().toLowerCase();
      if (t === 'menu' && all[j].children.length <= 2) return all[j];
    }
    return null;
  }

  /* Drop a home link with the logo immediately after the hamburger. The
     theme re-renders its header on soft navigation, so this runs from
     ensure() and re-attaches whenever the copy goes missing. */
  function mountMobileLogo() {
    if (document.querySelector('.cd-mlogo')) return;

    var toggle = menuToggle();
    if (!toggle || !toggle.parentNode) return;

    /* The toggle is a <summary>, so its siblings are the dropdown's own
       contents and would only show while the menu is open. Step out to the
       <details> and sit after that, in the header row itself. */
    var anchorEl = toggle.tagName === 'SUMMARY'
      ? (toggle.closest('details') || toggle)
      : toggle;
    if (!anchorEl.parentNode) return;

    var src = themeLogoImg();
    if (!src) return;

    var a = document.createElement('a');
    a.className = 'cd-mlogo';
    a.href = '/';
    a.setAttribute('aria-label', 'Coilover Depot home');

    var copy = document.createElement('img');
    copy.src = src.currentSrc || src.src;
    if (src.getAttribute('srcset')) {
      copy.setAttribute('srcset', src.getAttribute('srcset'));
      copy.setAttribute('sizes', '120px');
    }
    copy.alt = 'Coilover Depot';
    a.appendChild(copy);

    anchorEl.parentNode.insertBefore(a, anchorEl.nextSibling);
  }

  function buildSearchBar() {
    if (sbar && document.body.contains(sbar)) return;

    sbar = document.createElement('div');
    sbar.className = 'cd-sbar';
    sbar.innerHTML =
      '<div class="cd-sbar-in">' +
        '<div class="cd-sbar-box">' +
          '<input type="text" class="cd-sbar-q" ' +
            'placeholder="Search parts, brands, SKUs..." autocomplete="off">' +
          '<button class="cd-sbar-go" type="button" aria-label="Search">' +
            '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">' +
            '<circle cx="8.5" cy="8.5" r="6" fill="none" stroke="currentColor" ' +
            'stroke-width="2"></circle>' +
            '<line x1="13" y1="13" x2="18" y2="18" stroke="currentColor" ' +
            'stroke-width="2" stroke-linecap="round"></line></svg>' +
          '</button>' +
        '</div>' +
      '</div>';
    placeChrome(sbar);

    var input = sbar.querySelector('.cd-sbar-q');
    var params = new URLSearchParams(location.search);
    if (params.get('q')) input.value = params.get('q');

    attachSearch(input, true);

    sbar.querySelector('.cd-sbar-go').addEventListener('click', function () {
      var q = input.value.trim();
      if (onSearchPage()) {
        window.dispatchEvent(new CustomEvent('cd:query', { detail: q }));
      } else {
        location.href = '/search?q=' + encodeURIComponent(q);
      }
    });
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      var q = input.value.trim();
      if (onSearchPage()) {
        window.dispatchEvent(new CustomEvent('cd:query', { detail: q }));
      } else {
        location.href = '/search?q=' + encodeURIComponent(q);
      }
    });
  }

  function onSearchPage() {
    return location.pathname.indexOf('/search') === 0;
  }

  /* Hide nav entries the garage and search bar make redundant. */
  function hideRedundantNav() {
    var labels = CFG.hideNavLabels || [];
    if (!labels.length) return;
    /* Turbo's mega-menu triggers are not always anchors, so check buttons
       and spans too. The length guard stops a whole nav container being
       hidden when it happens to contain only this one label. */
    var nodes = document.querySelectorAll('a, button, [role="button"], li > span');
    Array.prototype.forEach.call(nodes, function (n) {
      if (n.closest('.cd-sbar') || n.closest('.cd-bar') || n.closest('.cd-modal')) return;
      var t = (n.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t.length > 40 || labels.indexOf(t) === -1) return;
      var target = n.closest('li') || n;
      target.style.setProperty('display', 'none', 'important');
    });
  }

  /* Turbo keeps its own search icon in the header; with our bar below the
     nav, two search affordances is one too many. */
  function hideThemeSearch() {
    if (!CFG.hideThemeSearch) return;
    var sels = ['.search-container', '.header__search', '.site-header__search',
                '.icon-search', '.search-submit', '.header-search', '.nav-search',
                '.search-link', '[class*="search-toggle"]', '[data-search-toggle]',
                '.mobile-nav__search', '.nav-search-link'];
    sels.forEach(function (sel) {
      var found;
      try { found = document.querySelectorAll(sel); } catch (e) { return; }
      Array.prototype.forEach.call(found, function (n) {
        if (n.closest('.cd-sbar') || n.closest('.cd-bar')) return;
        n.style.setProperty('display', 'none', 'important');
      });
    });

    /* Turbo also renders a bare icon link to /search in the header. It has
       no text of its own, so match on that rather than a class name. */
    var links = document.querySelectorAll('a[href*="/search"]');
    Array.prototype.forEach.call(links, function (a) {
      if (a.closest('.cd-sbar') || a.closest('.cd-bar')) return;
      if (a.closest('.cd-cwrap') || a.closest('.cd-sp')) return;
      var txt = (a.textContent || '').replace(/\s+/g, '').trim();
      if (txt.length) return;
      var box = a.closest('li') || a;
      box.style.setProperty('display', 'none', 'important');
    });
  }

  // ------------------------------------------------------------ header search
  function attachSearch(input, isMain) {
    if (input.dataset.cdBound) return;
    input.dataset.cdBound = '1';
    input.dataset.cdMain = isMain ? '1' : '';
    input.setAttribute('autocomplete', 'off');

    var dd = document.createElement('div');
    dd.className = 'cd-dd';
    dd.hidden = true;
    document.body.appendChild(dd);

    var timer, lastQ = '', scoped = true;

    function place() {
      var r = input.getBoundingClientRect();
      dd.style.top = (r.bottom + window.scrollY + 4) + 'px';
      dd.style.left = (r.left + window.scrollX) + 'px';
      dd.style.width = Math.max(320, r.width) + 'px';
    }

    function hide() { dd.hidden = true; }

    function go(q) {
      var v = Garage.get();
      var f = scoped ? vehicleFilter() : null;
      multi([{
        indexUid: CFG.index, q: q, limit: 6,
        filter: f ? [f] : [],
        attributesToRetrieve: ['title', 'vendor', 'price', 'url', 'image', 'in_stock']
      }]).then(function (d) {
        var res = d.results[0];
        var hits = res.hits || [];
        var html = '';

        if (scoped && v) {
          html += '<div class="cd-dd-note"><span>Showing parts for your ' +
            h(label(v)) + '</span>' +
            '<button data-cd="unscope">Search all vehicles</button></div>';
        }

        if (!hits.length) {
          html += '<div class="cd-dd-empty">No matches' +
            (scoped && v ? ' for your ' + h(label(v)) : '') + '.</div>';
        } else {
          html += hits.map(function (x) {
            var meta = [];
            if (x.vendor) meta.push(h(x.vendor));
            if (x.price) meta.push('$' + Number(x.price).toFixed(2));
            if (!x.in_stock) meta.push('Out of stock');
            return '<a class="cd-hit" href="' + h(x.url) + '">' +
              (x.image ? '<img src="' + h(x.image) + '" alt="" loading="lazy">' : '') +
              '<span class="cd-hit-w">' +
                '<span class="cd-hit-t">' + h(x.title) + '</span>' +
                '<span class="cd-hit-m">' + meta.join(' &middot; ') + '</span>' +
              '</span></a>';
          }).join('');
          html += '<a class="cd-dd-all" href="/search?q=' + encodeURIComponent(q) + '">' +
            'See all ' + (res.estimatedTotalHits || 0).toLocaleString() + ' results</a>';
        }

        dd.innerHTML = html;
        place();
        dd.hidden = false;
      }).catch(function () { hide(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (isMain && onSearchPage()) {
        /* On the results page the grid updates directly; no dropdown. */
        clearTimeout(timer);
        timer = setTimeout(function () {
          window.dispatchEvent(new CustomEvent('cd:query', { detail: q }));
        }, 200);
        hide();
        return;
      }
      if (q.length < 2) { hide(); return; }
      if (q === lastQ && !dd.hidden) return;
      lastQ = q;
      // Every dropdown pass is a billed query, so the debounce is tuned to
      // fire about once per typed word rather than once per character.
      timer = setTimeout(function () { go(q); }, 280);
    });

    input.addEventListener('focus', function () {
      if (isMain && onSearchPage()) return;
      if (input.value.trim().length >= 2) go(input.value.trim());
    });

    dd.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cd="unscope"]');
      if (b) { scoped = false; go(input.value.trim()); }
    });

    document.addEventListener('click', function (e) {
      if (e.target !== input && !dd.contains(e.target)) hide();
    });
    window.addEventListener('resize', place);
    window.addEventListener('scroll', function () { if (!dd.hidden) place(); });
  }

  function bindInputs() {
    var found = document.querySelectorAll(
      'input[name="q"], input[type="search"], .search-bar input[type="text"]'
    );
    Array.prototype.forEach.call(found, function (input) {
      if (input.dataset.cdBound) return;
      if (CFG.suppressOther) {
        // Searchanise is injected as an app ScriptTag and binds to the same
        // input. Replacing the node with a clone drops every listener that
        // was attached to the original, leaving the field clean for us.
        var fresh = input.cloneNode(true);
        if (input.parentNode) {
          input.parentNode.replaceChild(fresh, input);
          input = fresh;
        }
      }
      attachSearch(input);
    });
  }

  // -------------------------------------------------------- collection pages
  var col = { handle: null, grid: null, mine: null, note: null,
              offset: 0, total: 0, sort: '', types: [], vendors: [],
              stock: false };

  function collectionHandle() {
    var m = location.pathname.match(/^\/collections\/([^\/]+)\/?$/);
    if (!m) return null;
    var handle = m[1];
    /* /collections/all is a virtual collection, not a membership value. */
    return handle === 'all' ? '' : handle;
  }

  /* Locate the product grid: the element with the most DIRECT children that
     each contain a product link. A grid of 12 cards scores 12; its wrapper
     scores 1 or 2. Works without knowing the theme's class names. */
  function findGrid() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    if (links.length < 3) return null;

    var cands = [];
    Array.prototype.forEach.call(links, function (a) {
      var p = a.parentNode;
      for (var d = 0; d < 5 && p && p !== document.body; d++) {
        if (cands.indexOf(p) === -1) cands.push(p);
        p = p.parentNode;
      }
    });

    var best = 0, bestNode = null;
    cands.forEach(function (node) {
      var kids = node.children || [];
      var n = 0;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].querySelector && kids[i].querySelector('a[href*="/products/"]')) n++;
        else if (kids[i].matches && kids[i].matches('a[href*="/products/"]')) n++;
      }
      if (n > best) { best = n; bestNode = node; }
    });

    return best >= 3 ? bestNode : null;
  }

  function colFilters(skip) {
    var f = [];
    var v = vehicleFilter();
    if (v) f.push(v);
    if (col.handle) f.push('collections = ' + esc(col.handle));
    if (col.types.length && skip !== 'product_type') {
      f.push('(' + col.types.map(function (t) {
        return 'product_type = ' + esc(t);
      }).join(' OR ') + ')');
    }
    if (col.vendors.length && skip !== 'vendor') {
      f.push('(' + col.vendors.map(function (x) {
        return 'vendor = ' + esc(x);
      }).join(' OR ') + ')');
    }
    if (col.stock) f.push('in_stock = true');
    return f;
  }

  function colChecks(box, name, res, sel) {
    var d = (res && res.facetDistribution && res.facetDistribution[name]) || {};
    /* Alphabetical, case-insensitive and number-aware, so a shopper can
       scan for a known brand instead of hunting by product count. */
    var keys = Object.keys(d).sort(function (a, b) {
      return a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true });
    });
    if (!keys.length) { box.innerHTML = '<div class="cd-copt">None</div>'; return; }
    box.innerHTML = keys.map(function (k) {
      return '<label class="cd-copt"><input type="checkbox" value="' + h(k) + '"' +
        (sel.indexOf(k) !== -1 ? ' checked' : '') + '>' + h(k) +
        '<span class="n">' + d[k] + '</span></label>';
    }).join('');
    Array.prototype.forEach.call(box.querySelectorAll('input'), function (cb) {
      cb.addEventListener('change', function () {
        var i = sel.indexOf(cb.value);
        if (cb.checked && i === -1) sel.push(cb.value);
        if (!cb.checked && i !== -1) sel.splice(i, 1);
        col.offset = 0;
        runCollection(false);
      });
    });
  }

  function colChips() {
    var box = col.mine && col.mine.querySelector('.cd-cchips');
    if (!box) return;
    var c = [];
    col.types.forEach(function (t) { c.push(['type', t]); });
    col.vendors.forEach(function (v) { c.push(['vendor', v]); });
    if (col.stock) c.push(['stock', 'In stock']);
    box.innerHTML = c.map(function (x) {
      return '<span class="cd-cchip">' + h(x[1]) +
        '<button data-ck="' + x[0] + '" data-cv="' + h(x[1]) + '">&times;</button></span>';
    }).join('');
    Array.prototype.forEach.call(box.querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-ck'), v = b.getAttribute('data-cv');
        if (k === 'type') col.types.splice(col.types.indexOf(v), 1);
        if (k === 'vendor') col.vendors.splice(col.vendors.indexOf(v), 1);
        if (k === 'stock') {
          col.stock = false;
          var sc = col.mine.querySelector('.cd-cstock');
          if (sc) sc.checked = false;
        }
        col.offset = 0;
        runCollection(false);
      });
    });
  }

  function renderColNote() {
    if (!col.note) return;
    var v = Garage.get();
    if (!v) { col.note.innerHTML = ''; return; }
    /* Leads out of this collection to everything that fits the vehicle.
       The search page reads the garage, so no parameters are needed. */
    col.note.innerHTML = '<span>Showing parts that fit your <b>' +
      h(label(v)) + '</b></span>' +
      '<a class="cd-cnote-a" href="/search">Show all parts for this vehicle</a>';
  }

  function stars(x) {
    if (!x.review_count) return '';
    var full = Math.round(x.rating);
    var out = '';
    for (var i = 1; i <= 5; i++) out += (i <= full ? '\u2605' : '\u2606');
    return '<span class="cd-cr">' + out +
      '<span class="cd-crn">(' + x.review_count + ')</span></span>';
  }

  function colCard(x) {
    return '<a class="cd-cc" href="' + h(x.url) + '">' +
      '<span class="cd-cc-i">' +
      (x.image ? '<img src="' + h(x.image) + '" alt="" loading="lazy">' : '') +
      '</span><span class="cd-cc-b">' +
      '<span class="cd-cc-v">' + h(x.vendor) + '</span>' +
      '<span class="cd-cc-t">' + h(x.title) + '</span>' +
      stars(x) +
      '<span class="cd-cc-p">' +
      (x.price ? '$' + Number(x.price).toLocaleString(undefined,
        { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '') +
      (x.in_stock ? '' : ' <span class="cd-cc-o">Out of stock</span>') +
      '</span></span></a>';
  }

  function runCollection(append) {
    if (!col.mine) return;
    var body = {
      indexUid: CFG.index, q: '', limit: 24, offset: col.offset,
      filter: colFilters(null),
      attributesToRetrieve: ['title', 'vendor', 'price', 'url', 'image',
                             'in_stock', 'rating', 'review_count']
    };
    if (col.sort) body.sort = [col.sort];

    /* Each facet list is queried without its own filter applied, so the
       other options stay visible with counts instead of collapsing. When
       a facet has nothing selected, though, that filter set is identical
       to the main query's, so its counts ride along on the main query for
       free. Only a facet the shopper has actually filtered on needs one of
       its own, which makes the common case a single search. */
    var queries = [body];
    var slot = {};
    var ownFacets = [];

    ['product_type', 'vendor'].forEach(function (name) {
      var active = (name === 'product_type' ? col.types : col.vendors).length;
      if (!active) { ownFacets.push(name); return; }
      slot[name] = queries.length;
      queries.push({ indexUid: CFG.index, q: '', limit: 0,
                     filter: colFilters(name), facets: [name] });
    });
    if (ownFacets.length) body.facets = ownFacets;

    multi(queries).then(function (d) {
      var res = d.results[0];
      function facetRes(name) {
        return slot[name] === undefined ? res : d.results[slot[name]];
      }
      colChecks(col.mine.querySelector('[data-cf="product_type"] .cd-clist'),
                'product_type', facetRes('product_type'), col.types);
      colChecks(col.mine.querySelector('[data-cf="vendor"] .cd-clist'),
                'vendor', facetRes('vendor'), col.vendors);
      colChips();
      col.total = res.estimatedTotalHits || 0;
      var html = (res.hits || []).map(colCard).join('');
      var body = col.mine.querySelector('.cd-cg');
      if (append) body.insertAdjacentHTML('beforeend', html);
      else body.innerHTML = html || '<div class="cd-cempty">Nothing in this collection fits your vehicle.</div>';
      var more = col.mine.querySelector('.cd-cmore');
      more.hidden = (col.offset + 24) >= col.total;
      var cnt = col.mine.querySelector('.cd-ccount');
      if (cnt) cnt.textContent = col.total.toLocaleString() +
        ' product' + (col.total === 1 ? '' : 's');
      renderColNote();
    }).catch(function () {
      showNative();
      if (col.mine) col.mine.hidden = true;
    });
  }

  function showNative() {
    if (col.grid) col.grid.style.display = '';
    if (col.mine) col.mine.hidden = true;
  }
  function showMine() {
    if (col.grid) col.grid.style.display = 'none';
    if (col.mine) col.mine.hidden = false;
  }

  function setupCollection() {
    var handle = collectionHandle();
    if (handle === null) return;
    if (col.mine && document.body.contains(col.mine)) return;

    col.handle = handle;
    col.grid = findGrid();
    col.offset = 0;
    col.sort = '';

    var wrap = document.createElement('div');
    wrap.className = 'cd-cwrap';
    wrap.innerHTML =
      '<div class="cd-cnote"></div>' +
      '<div class="cd-clayout">' +
        '<aside class="cd-cside">' +
          '<div class="cd-cfacet cd-csortgroup">' +
            '<div class="cd-cft">Sort by</div>' +
            '<select class="cd-csort">' +
              '<option value="">Featured</option>' +
              '<option value="rating_score:desc">Top rated</option>' +
              '<option value="review_count:desc">Most reviewed</option>' +
              '<option value="price:asc">Price: Low to High</option>' +
              '<option value="price:desc">Price: High to Low</option>' +
              '<option value="title:asc">Name: A-Z</option>' +
            '</select>' +
          '</div>' +
          '<div class="cd-cfacet" data-cf="product_type">' +
            '<div class="cd-cft">Product type</div><div class="cd-clist"></div>' +
          '</div>' +
          '<div class="cd-cfacet" data-cf="vendor">' +
            '<div class="cd-cft">Brand</div><div class="cd-clist"></div>' +
          '</div>' +
          '<div class="cd-cfacet">' +
            '<label class="cd-cchk"><input type="checkbox" class="cd-cstock">' +
            ' In stock only</label>' +
          '</div>' +
        '</aside>' +
        '<div class="cd-cmain">' +
          '<div class="cd-cbar">' +
            '<span class="cd-ccount"></span>' +
          '</div>' +
          '<div class="cd-cchips"></div>' +
          '<div class="cd-cg"></div>' +
          '<div class="cd-cmore-wrap">' +
            '<button class="cd-cmore" type="button" hidden>Load more</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    /* Prefer the theme's own grid position; otherwise drop into the main
       content wrapper, since Searchanise leaves no grid behind. */
    if (col.grid && col.grid.parentNode) {
      col.grid.style.display = 'none';
      col.grid.parentNode.insertBefore(wrap, col.grid.nextSibling);
    } else {
      var host = document.querySelector('.section-wrapper') || document.body;
      host.insertBefore(wrap, host.firstChild);
    }
    col.mine = wrap;
    col.note = wrap.querySelector('.cd-cnote');
    makeDrawer(wrap.querySelector('.cd-cside'),
               wrap.querySelector('.cd-cbar'), 'Sort & Filter');

    wrap.querySelector('.cd-cmore').addEventListener('click', function () {
      col.offset += 24;
      runCollection(true);
    });
    wrap.querySelector('.cd-csort').addEventListener('change', function () {
      col.sort = this.value;
      col.offset = 0;
      runCollection(false);
    });
    wrap.querySelector('.cd-cstock').addEventListener('change', function () {
      col.stock = this.checked;
      col.offset = 0;
      runCollection(false);
    });

    applyCollection();
  }

  function applyCollection() {
    if (!col.mine) return;
    col.offset = 0;
    runCollection(false);
  }


  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cd]');
    if (!t) return;
    var a = t.getAttribute('data-cd');
    if (a === 'clear') {
      e.preventDefault();
      Garage.clear();
      if (sel.make) { sel.make.value = ''; loadModels('', ''); }
      if (onSearchPage()) window.dispatchEvent(new CustomEvent('cd:refresh'));
      else applyCollection();
    }
    if (a === 'apply') { e.preventDefault(); applyPick(); }

  });

  window.addEventListener('cd:garage', function () {
    renderBar();
    applyCollection();
  });

  // ------------------------------------------------------------ drawer
  var scrim;
  function makeDrawer(side, barEl, labelText) {
    if (!side || side.dataset.cdDrawer) return;
    side.dataset.cdDrawer = '1';
    side.classList.add('cd-drawer');

    if (!scrim || !document.body.contains(scrim)) {
      scrim = document.createElement('div');
      scrim.className = 'cd-scrim';
      document.body.appendChild(scrim);
      scrim.addEventListener('click', closeDrawer);
    }

    var close = document.createElement('button');
    close.className = 'cd-dclose';
    close.type = 'button';
    close.setAttribute('aria-label', 'Close filters');
    close.innerHTML = '&times;';
    close.addEventListener('click', closeDrawer);
    side.insertBefore(close, side.firstChild);

    if (barEl) {
      var open = document.createElement('button');
      open.className = 'cd-fbtn';
      open.type = 'button';
      open.textContent = labelText || 'Filters';
      open.addEventListener('click', function () {
        side.classList.add('open');
        scrim.classList.add('open');
      });
      barEl.insertBefore(open, barEl.firstChild);
    }
  }

  function closeDrawer() {
    var open = document.querySelectorAll('.cd-drawer.open');
    Array.prototype.forEach.call(open, function (d) { d.classList.remove('open'); });
    if (scrim) scrim.classList.remove('open');
  }

  // ------------------------------------------------------------------ public
  window.CDMeili = {
    cfg: CFG,
    host: host,
    multi: multi,
    garage: Garage,
    vehicleFilter: vehicleFilter,
    label: label,
    esc: esc,
    escapeHtml: h,
    applyVehicle: applyPick,
    makeDrawer: makeDrawer,
    closeDrawer: closeDrawer
  };

  function ensure() {
    // InstantClick swaps the DOM without reloading scripts, so the bar and
    // any search inputs have to be re-established after each navigation.
    if (CFG.showBar) {
      if (!bar || !document.body.contains(bar)) {
        bar = null;
        buildBar();
      } else if (isHidden(bar)) {
        // Something hid the container the bar lives in; move it out rather
        // than leaving the shopper with no way to change vehicle.
        placeChrome(bar);
      }
    }
    if (sbar && document.body.contains(sbar) && isHidden(sbar)) {
      placeChrome(sbar);
    }
    bindInputs();
    buildSearchBar();
    mountMobileLogo();
    hideRedundantNav();
    hideThemeSearch();
    setupCollection();
  }

  function init() {
    ensure();

    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; ensure(); }, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // Hook InstantClick directly when it is available; the observer above
    // is the fallback for themes or pages where it is not.
    var tries = 0;
    var poll = setInterval(function () {
      if (window.InstantClick && window.InstantClick.on) {
        clearInterval(poll);
        try { window.InstantClick.on('change', ensure); } catch (e) {}
      } else if (++tries > 40) {
        clearInterval(poll);
      }
    }, 250);

    // Safety net: a soft navigation can replace the container between the
    // observer firing and the bar being inserted, leaving nothing behind.
    // This costs one DOM check a second and always recovers.
    setInterval(function () {
      if (!CFG.showBar) return;
      if (!bar || !document.body.contains(bar) || isHidden(bar)) ensure();
    }, 1000);

    // Back/forward through the bfcache does not fire the observer.
    window.addEventListener('pageshow', ensure);
    window.addEventListener('popstate', ensure);

    /* Rotating a phone or resizing a window can cross the mobile
       breakpoint, which changes where the bars belong. Re-place only on
       an actual crossing, so ordinary resizes cost nothing. */
    var wasMobile = isMobile();
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var now = isMobile();
        if (now === wasMobile) return;
        wasMobile = now;
        if (bar && document.body.contains(bar)) placeChrome(bar);
        if (sbar && document.body.contains(sbar)) placeChrome(sbar);
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();